


























import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM } from "@/plugins/axios";
import AccountLoginCmp from "./accountLoginCmp.vue";
import FastLoginCmp from "./fastLoginCmp.vue";
@Component({
  components: {
    AccountLoginCmp,
    FastLoginCmp
  }
})
export default class LoginView extends Vue {
  private cState: "account" | "fast" = "account";

  /**
   * @description 前往注册
   */
  private goToRegister() {
    this.$router.push("/access/register");
  }
  /**
   * @description 打开QAndA
   */
  private openQandA() {
    // const uri =
    //   "https://zydata.oss-cn-shanghai.aliyuncs.com/ds/docs/%E5%B2%90%E9%BB%84%E6%95%B0%E6%8D%AEAI%E5%B7%A5%E4%BD%9C%E7%AB%99Q%26A%28V1.0%29.docx";
    // localStorage.setItem("word-preview", uri);
    // window.open("/#/word-preview");
    const uri: any =
      "https://zydata.oss-cn-shanghai.aliyuncs.com/ds/docs/%E5%B2%90%E9%BB%84%E6%95%B0%E6%8D%AEAI%E5%B7%A5%E4%BD%9C%E7%AB%99-%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98-1.0%E7%89%88.pdf";
    window.open(uri);
  }
}
